import { useEffect, useRef } from 'react';
import { createConsumer } from '@rails/actioncable';

const useDealerBidding = (listingId, callbacks = {}) => {
  const consumerRef     = useRef(null);
  const subscriptionRef = useRef(null);
  const callbacksRef    = useRef(callbacks);
  callbacksRef.current  = callbacks;

  useEffect(() => {
    if (!listingId) return;

    const token  = localStorage.getItem('dealerToken') || localStorage.getItem('authToken');
    const wsBase = process.env.REACT_APP_WS_URL || 'ws://localhost:3001/cable';

    if (!token) {
      console.warn('[Cable] No token found — WebSocket will be rejected');
    }

    const wsUrl = token ? `${wsBase}?token=${encodeURIComponent(token)}` : wsBase;

    console.log(`[Cable] Connecting to ${wsBase} for listing ${listingId}`);

    const consumer = createConsumer(wsUrl);
    consumerRef.current = consumer;

    subscriptionRef.current = consumer.subscriptions.create(
      { channel: 'DealerBiddingChannel', listing_id: Number(listingId) },
      {
        connected() {
          console.log(`[Cable] Connected to listing ${listingId}`);
          callbacksRef.current.onConnected?.();
        },

        disconnected() {
          console.log(`[Cable] Disconnected from listing ${listingId}`);
          callbacksRef.current.onDisconnected?.();
        },

        received(data) {
          console.log(`[Cable] Received for listing ${listingId}:`, data);
          switch (data.type) {
            case 'SNAPSHOT':
              callbacksRef.current.onSnapshot?.(data);
              break;
            case 'NEW_BID':
              callbacksRef.current.onNewBid?.(data);
              break;
            case 'BID_RESULT':
              callbacksRef.current.onBidResult?.(data);
              break;
            default:
              console.log('[Cable] Unknown message type:', data.type);
          }
        },
      }
    );

    return () => {
      console.log(`[Cable] Cleaning up listing ${listingId}`);
      subscriptionRef.current?.unsubscribe();
      consumer.disconnect();
      consumerRef.current  = null;
      subscriptionRef.current = null;
    };
  }, [listingId]); // Only re-run if listingId changes
};

export default useDealerBidding;